import React from 'react'
import PropTypes from 'prop-types'

const Input = ({ label, value, onChange }) => (
  <div className="flex items-center mb-2">
    <label htmlFor="name" className="text-right w-16">
      {label}:
    </label>
    <input
      type="text"
      className="flex-1 p-2 ml-4 input bg-gray-50"
      id={label}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  </div>
)

Input.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
}

export default Input
